var file_upload_viewer_default = {
  "fontElementMap": "d3EuK",
  "file_upload_container": "iiwwM",
  "file_upload_link": "V3a7m",
  "file_upload_error_container": "d0kD1",
  "file_upload_file_info": "Ir6K7",
  "file_upload_type_icon": "b-Gva",
  "file_upload_status_icon_container": "AUkby",
  "file_upload_status_icon": "SC9Iq",
  "file_upload_description": "tCiOI",
  "file_upload_name_container": "nI-Gd",
  "file_upload_name": "Mm-WM",
  "file_upload_extension": "Fa4xj",
  "file_loader_icon": "_3dMw-",
  "file_upload_icon_frame": "_2MMUf",
  "file_upload_icon_background": "lgoIw"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
